import React, {useEffect} from "react";
import { FaReact } from "react-icons/fa";
import {
  SiClaude,
  SiPython,
  SiTypescript,
  SiOpenjdk,
  SiAmazonwebservices,
  SiApachekafka,
  SiCloudflare,
} from "react-icons/si";
import Layout from "../components/Layout";
import AOS from 'aos';

AOS.init({
  duration: 1000, // values from 0 to 3000, with step 50ms,

});
function Home() {
  useEffect(() => {
    window.scrollTo(0,0)
      }, [])
  return (
    <Layout>
      <div className="  " >
        <div className="pro h-screen xl:overflow-x-hidden  " >
          <div className="grid lg:grid-cols-1 grid-cols-2    h-full items-center border-2 border-white transform rotate-12 lg:rotate-0 mx-10  md:mx-1 rounded-xl   md:shadow-2xl md:rounded-xl shadow-xl shadow-rb" >
            <div className="h-3/4 md:h-full" data-aos='zoom-in-up'>
              <lottie-player
                src="https://assets2.lottiefiles.com/packages/lf20_kkflmtur.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>
            <div className=" font-bold text-white lg:text-center ">
              <h1 className="text-9xl md:text-5xl xl:text-5xl lg:text-[6rem] lg:-mt-[10rem]" data-aos='slide-right' >
                Hey, I'm <b className="text-yellow-500">LUIS</b>
              </h1>
              <h1 className="text-6xl lg:text-[3rem] md:text-[2rem] p-1 lg:pt-5" data-aos='slide-left'>
                {" "}
                AI <b className="text-cyan-300">Engineer</b>{" "}
              </h1>
              <h1 data-aos='fade-down-right'className=" text-4xl md:p-1 md:text-2xl lg:text-[2.5rem]  xl:text-2xl lg:pt-3">
                <b className="text-yellow-500">🇨🇴 First</b> 
                <b className="text-blue-500">-</b> 
                <b className="text-red-500">Generation</b> 
                {" "}Alumn
              </h1>
              <h1 data-aos='fade-down-right'className=" text-3xl md:p-1 md:text-2xl lg:text-[2.5rem]  xl:text-2xl lg:pt-3">
              <a href='https://www.stern.nyu.edu/' target="_blank"> <b className="text-purple-500 hover:animate-pulse">NYU Stern</b> </a> |{" "}
              <a href='https://flatironschool.com/' target="_blank"> <b className="text-sky-400 hover:animate-pulse">Flatiron</b> |{" "}</a>
              <a href='https://opportunitynetwork.org/' target="_blank"> <b className="text-orange-400 hover:animate-pulse">Opportunity Network</b> </a>
              </h1>
              <h1 data-aos='fade-down-right' className=" text-3xl md:p-1 md:text-2xl lg:text-[2.5rem]  xl:text-2xl lg:pt-3">
                Ex-<b className="text-sky-400">VMware</b> Software Engineer
              </h1>
            </div>
          </div>
        </div>
        <div className=" lg:mt-10 xl:pt-10 mt-[150px] border-t border-white border-2 rounded-2xl  p-3 shadow-2xl shadow-v">
          <h1 data-aos='flip-down' className="text-7xl lg:text-5xl md:text-4xl text-white font-bold text-center my-8  ">
            Technologies I Use
          </h1>
          <div data-aos="zoom-in"  className="grid md:grid-cols-1 grid-cols-4 ">
            <SiClaude
              size={180}
              color="#D97757"
              className="w-full text-center mt-20 animate-pulse"
              title="Claude Code & Claude API"
            />
            <SiPython
              size={180}
              color="#FFD43B"
              className="w-full text-center mt-20 animate-bounce"
              title="Python"
            />
            <SiTypescript
              size={180}
              color="#3178C6"
              className="w-full text-center mt-20 animate-pulse"
              title="TypeScript"
            />
            <FaReact
              size={180}
              color="cyan"
              className="w-full text-center mt-20 animate-bounce"
              title="React & React Native"
            />
            <SiOpenjdk
              size={180}
              color="#F89820"
              className="w-full text-center mt-20 animate-pulse"
              title="Java"
            />
            <SiAmazonwebservices
              size={180}
              color="#FF9900"
              className="w-full text-center mt-20 animate-bounce"
              title="AWS Cloud"
            />
            <SiApachekafka
              size={180}
              color="white"
              className="w-full text-center mt-20 animate-pulse"
              title="Kafka"
            />
            <SiCloudflare
              size={180}
              color="#F38020"
              className="w-full text-center mt-20 animate-bounce"
              title="Cloudflare Workers"
            />
          </div>
        </div>
        <div data-aos="zoom-in" className="my-10 border-t border-white border-2 rounded-2xl  p-3 shadow-2xl shadow-v">
          <div className="text-center ">
            <h1 className="text-white font-bold text-4xl md:text-3xl py-10 sm:mx-10 sm:text-2xl">
              Building AI Agents Where Code Checks the Model
            </h1>
          </div>
          <div className="md:mx-5   p-4 mt-[-6rem] md:mt-[-8rem] rounded-lg  z-50  ">
            <div className="h-[400px] mt-3 md:mt-10">
              <lottie-player
                src="https://assets5.lottiefiles.com/packages/lf20_6gfl0jjp.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>
            <p className="text-2xl text-white text-center">
              {" "}
              Agents write a lot of my code. I design it, review it and test it. In everything I build, the model reads and writes things down, and code decides.
            </p>
          </div>
        </div>
        <div data-aos="zoom-in" className="my-10 border-t border-white border-2 rounded-2xl  p-3 shadow-2xl shadow-v">
          <div className="text-center">
            <h1 className="text-white font-bold text-4xl md:text-3xl py-10">
              2 Years at <b className="text-sky-400">VMware</b>
            </h1>
          </div>
          <div className="grid md:grid-cols-1 grid-cols-3 text-white text-center gap-6 mx-10 md:mx-2">
            <div>
              <p className="text-6xl md:text-5xl font-bold text-green-400">2M+</p>
              <p className="font-semibold mt-2">users on CloudHealth, where I built batch account reassignment</p>
            </div>
            <div>
              <p className="text-6xl md:text-5xl font-bold text-cyan-400">98%</p>
              <p className="font-semibold mt-2">less manual work moving cloud accounts, by my estimate</p>
            </div>
            <div>
              <p className="text-6xl md:text-5xl font-bold text-orange-400">3,000+</p>
              <p className="font-semibold mt-2">report downloads a day, on the dashboard I built</p>
            </div>
          </div>
          <ul className="text-white text-lg md:text-base mx-32 md:mx-3 my-10 space-y-3 list-disc pl-5">
            <li>Architected and built batch account reassignment: users changing departments move their cloud accounts in two clicks, and engineers batch AWS, Azure and GCP accounts in one API call.</li>
            <li>Led the cross-functional design of a distributed org-movement service with product and 8+ teams, designed to scale to 20,000+ enterprise customers.</li>
            <li>Migrated the AWS and Azure security policy engine from a Rails monolith to a Java service, then built a Kafka onboarding pipeline attaching policies to 100+ accounts a week.</li>
            <li>Wrote the first cut of a Python script turning service configs into Terraform modules for a multi-region AWS migration: 10+ services a day, 30% faster.</li>
            <li>On call for authentication and onboarding on Kubernetes, with code reviews and mentoring for other teams.</li>
          </ul>
        </div>
        <div data-aos="zoom-in" className="my-10 border-t border-white border-2 rounded-2xl  p-3 shadow-2xl shadow-v">
          <div className="text-center">
            <h1 className="text-white font-bold text-4xl py-10">
              My Dev Stack
            </h1>
          </div>
          <div className="md:mx-5 mx-32   p-4 mt-[-6rem] rounded-lg  z-50  ">
            <div className="h-96">
              <lottie-player
                src="https://assets2.lottiefiles.com/packages/lf20_lln7m43m.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>
            <div className="grid md:grid-cols-1  grid-cols-3 text-white md:text-sm">
              <div className="text-left">
                <h1 className="text-xl font-bold md:text-lg text-green-400">AI Development</h1>
                <hr />
                <p className="font-semibold mt-2">Claude Code</p>
                <p className="font-semibold mt-2">Claude API & Bedrock</p>
                <p className="font-semibold mt-2">Mistral</p>
                <p className="font-semibold mt-2">MCP</p>
                <p className="font-semibold mt-2">Evals & Tracing</p>
              </div>
              <div className="text-center">
                <h1 className="text-xl font-bold md:text-lg text-cyan-400">Modern Foundations</h1>
                <hr />
                <p className="font-semibold mt-2">TypeScript</p>
                <p className="font-semibold mt-2">Python</p>
                <p className="font-semibold mt-2">Java</p>
                <p className="font-semibold mt-2">React Native</p>
                <p className="font-semibold mt-2">FastAPI</p>
              </div>
              <div className="text-right">
                <h1 className="text-xl font-bold  md:text-lg md:mt-1 text-orange-400">
                  Infrastructure
                </h1>
                <hr />
                <p className="font-semibold mt-2">AWS Cloud</p>
                <p className="font-semibold mt-2">Kafka</p>
                <p className="font-semibold mt-2">Kubernetes</p>
                <p className="font-semibold mt-2">Terraform</p>
                <p className="font-semibold mt-2">Cloudflare Workers</p>
              </div>
            </div>
          </div>
        </div>
        <div data-aos="zoom-in" className="border-t  border-white border-2 rounded-2xl  p-3 shadow-2xl shadow-v">
          <h1 className="text-4xl text-white text-center font-bold  ">
            Who is Luis?
          </h1>
          <div className="h-screen md:h-fit lg:h-[auto] relative text-white  ">
            <div className="h-screen  md:mx-auto  mx-32   rounded-lg  z-50">
              <lottie-player
                src="https://assets5.lottiefiles.com/packages/lf20_gja1z1ru.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </div>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <h1 className=" ">
                <span className=" text-4xl md:text-lg text-center text-j">
                  🤫 Classified 🤫
                </span>
                <hr />
              </h1>

              <pre className="text-2xl md:text-xs tracking-widest font-mont font-semibold">
                {JSON.stringify(
                  {
                    Name: "Luis Alfredo Escobar",
                    Age: "26",
                    Gender: "Male",
                    Resides: "U.S.A",
                    Ethnicity: "Colombia",
                    'College Major': 'Finance',
                    Experience: 'VMware, 2 yrs',
                    Passion: 'Agentic Development'
                  },
                  null,
                  2
                )}
              </pre>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Home;
